/**
 * Gift card page: the amount pills drive the variant id and the amount shown on the card and the
 * button; the recipient email becomes required only when «send to a recipient» is ticked, and
 * Shopify's __shopify_offset gets the shopper's timezone so «Send on» lands on the right day.
 */
(() => {
  const form = document.querySelector('[data-gift-card-form]');
  if (!form) return;

  const id = form.querySelector('[data-gc-id]');
  const toggle = form.querySelector('[data-gc-recipient-toggle]');
  const email = form.querySelector('[data-gc-recipient-email]');
  const offset = form.querySelector('[data-gc-offset]');

  form.addEventListener('change', (event) => {
    if (event.target.name === 'gc-amount') {
      id.value = event.target.value;
      document.querySelectorAll('[data-gc-amount]').forEach((node) => {
        node.textContent = event.target.dataset.amount;
      });
    }

    if (event.target === toggle) {
      email.required = toggle.checked;
      if (toggle.checked) email.focus();
    }
  });

  if (offset) offset.value = String(new Date().getTimezoneOffset());
})();
